var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-pdf-app',{style:(_vm.is_mobile ? 'height: 80vh !important' : 'height: 90vh'),attrs:{"id":_vm.idComponent,"pdf":_vm.src,"config":_vm.config},on:{"open":_vm.openHandler,"pages-rendered":_vm.pagesRenderedHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }